<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2021-04-08 14:22:10
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>ZtoAd</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zto-ad/";
export default {
  name: "zto-ad",
  data() {
    return {
      fileList: [
        {
          label: '2.0.6',
          linkList: [
            ur + '2.0.6/ZtoAd.min.js'
          ]
        },
        {
          label: '2.0.5',
          linkList: [
            ur + '2.0.5/ZtoAd.min.js'
          ]
        },
        {
          label: '2.0.4',
          linkList: [
            ur + '2.0.4/ZtoAd.min.js'
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZtoAd.vue